// mixins/countdown.js
// Ticks every second while the component is mounted; components use formatRemaining(endsAt)
// instead of taking a pre-formatted remainingTime string as a prop.
import { parseDate } from '../utils/parseDate'

export default {
  data() {
    return { nowTimestamp: Date.now() }
  },
  mounted() {
    this._countdownTimer = setInterval(() => {
      this.nowTimestamp = Date.now()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this._countdownTimer)
  },
  methods: {
    formatRemaining(endsAt) {
      if (!endsAt) return ''
      const diff = parseDate(endsAt).getTime() - this.nowTimestamp
      if (diff <= 0) return '00:00:00'
      const totalSeconds = Math.floor(diff / 1000)
      const h = Math.floor(totalSeconds / 3600)
      const m = Math.floor((totalSeconds % 3600) / 60)
      const s = totalSeconds % 60
      const pad = (n) => String(n).padStart(2, '0')
      return `${pad(h)}:${pad(m)}:${pad(s)}`
    }
  }
}